/* Dhrohar 0.6.0 (owner workbook B6): Recently viewed products (sections/dhrohar-recently-viewed.liquid).
   Storage: localStorage "dhrohar:recent:v1" = [{ h: handle, t: time }], newest first, at most 12, this device only.
   Each card comes from /products/<handle>?section_id=dhrohar-recent-card, so price, MRP and stock are live.
   A product that returns 404 (deleted or unpublished) is dropped from the list. With storage blocked or nothing
   to show, the section stays hidden. */
(() => {
  if (customElements.get('dhrohar-recently-viewed')) return;

  const KEY = 'dhrohar:recent:v1';
  const MAX = 12;
  const HANDLE = /^[a-z0-9][a-z0-9-]{0,254}$/;

  const read = () => {
    try {
      const raw = JSON.parse(window.localStorage.getItem(KEY) || '[]');
      return Array.isArray(raw) ? raw.filter((x) => x && typeof x.h === 'string' && HANDLE.test(x.h)) : [];
    } catch (e) {
      return null; // storage blocked or unreadable
    }
  };
  const write = (list) => {
    try {
      window.localStorage.setItem(KEY, JSON.stringify(list.slice(0, MAX)));
    } catch (e) {
      /* storage full or blocked: nothing to do */
    }
  };

  class DhroharRecentlyViewed extends HTMLElement {
    connectedCallback() {
      if (this.started) return;
      this.started = true;
      const current = this.dataset.productHandle || '';
      const limit = Math.max(1, parseInt(this.dataset.limit, 10) || 4);
      const list = read();
      if (list === null) return; // no storage: stay hidden

      const show = [];
      const seen = new Set([current]);
      for (const item of list) {
        if (seen.has(item.h)) continue;
        seen.add(item.h);
        show.push(item.h);
        if (show.length >= limit) break;
      }
      if (current && HANDLE.test(current)) {
        write([{ h: current, t: Date.now() }, ...list.filter((x) => x.h !== current)]);
      }
      if (show.length && !(window.Shopify && window.Shopify.designMode)) this.render(show);
    }

    async render(handles) {
      const root = (window.Shopify && window.Shopify.routes && window.Shopify.routes.root) || '/';
      const results = await Promise.all(
        handles.map((h) =>
          fetch(`${root}products/${encodeURIComponent(h)}?section_id=dhrohar-recent-card`)
            .then((r) => (r.ok ? r.text() : { missing: r.status === 404 }))
            .catch(() => ({ missing: false }))
        )
      );
      const items = [];
      const gone = [];
      results.forEach((result, i) => {
        if (typeof result !== 'string') {
          if (result.missing) gone.push(handles[i]);
          return;
        }
        const item = new DOMParser().parseFromString(result, 'text/html').querySelector('[data-dh-recent-item]');
        if (item) items.push(item);
      });
      if (gone.length) {
        const list = read();
        if (list) write(list.filter((x) => !gone.includes(x.h)));
      }
      const target = this.querySelector('[data-dh-recent-list]');
      if (!items.length || !target) return;
      target.replaceChildren(...items.map((item) => document.importNode(item, true)));
      this.hidden = false;
    }
  }

  customElements.define('dhrohar-recently-viewed', DhroharRecentlyViewed);
})();
